module.exports = __webpack_public_path__ + "static/media/fresh-factory-banner2.422df5b4.png";